import React, { FC, Fragment } from 'react';
import { connect } from 'react-redux';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import ExchangeJobStatus from '../../Exchange/JobStatusReview/component';
import {
  openJobStatusReview, selectActiveUploads, selectFailedUploads, selectNumberCurrentUploads,
} from '../../../state/jobStatus';
import { VaultButton, FaIcon, ErrorIcon } from '../../Shared';

const ExchangeJobsButton: FC<IProps> = (props: IProps) => {
  const {
    onOpen,
  } = props;

  const getJobsStatusButton = () => {
    const { activeUploads, failedUploads, numActiveUploads } = props;
    let label:string;
    if (failedUploads !== undefined && failedUploads.length > 0) {
      return (
        <VaultButton
          variant="jobsErrorButton"
          onClick={onOpen}
          data-auto="JobsErrorBtn"
        >
          <>
            <ErrorIcon />
          </>
          ERROR
        </VaultButton>
      );
    }
    switch (numActiveUploads) {
      case (0):
        return (
          <VaultButton
            variant="transparentOnBlack"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            Jobs
          </VaultButton>
        );
      case (1):
        return (
          <VaultButton
            variant="jobsButton"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            <>
              <FaIcon
                icon={faSpinner}
                spin
                $small
              />
            </>
            Job in Progress
          </VaultButton>
        );
      default:
        return (
          <VaultButton
            variant="jobsButton"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            <>
              <FaIcon
                icon={faSpinner}
                spin
                $small
              />
            </>
            Jobs in Progress
          </VaultButton>
        );
    }
  };

  return (
    <>
      <VaultButton
        variant="transparentOnBlack"
        onClick={onOpen}
        data-auto="ExchangeJobsBtn"
      >
        {getJobsStatusButton()}
      </VaultButton>
      <ExchangeJobStatus />
    </>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  numActiveUploads: selectNumberCurrentUploads(state),
  activeUploads: selectActiveUploads(state),
  failedUploads: selectFailedUploads(state),
});

const mapDispatchToProps: IDispatchProps = {
  onOpen: openJobStatusReview,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeJobsButton);
